import useValidate from '@vuelidate/core';
import { helpers, required, maxLength } from '@vuelidate/validators';
import constants from '@/constants/constants';
import Validator from '@/validations/Validator';
import { inspection_criterias, types, freights } from '@/constants/constants';



class StockListValidator extends Validator {

    constructor() {
        super();

        
        
        //CUSTOM VALIDATIONS
        this.isType = function(value){
            value.includes('return', 'release');
        };



        //VALIDATIONS
        this.validations = {
            depot_id: {
                required: helpers.withMessage('<strong>Facility/Depot</strong> must be set', required)
            },
            matched_shipping_line: {
                required: helpers.withMessage('<strong>Shipping Line/Operator</strong> must be set', required)
            },
            matched_leasing_company: {
                required: helpers.withMessage('<strong>Leasing Company</strong> must be set', required)
            }
        };
        
        
        
        this.$v = useValidate(this.validations, this.validationData);        
    }

}

export default new StockListValidator();